import requests from './httpService';
const LessonService = {
  getAllLesson(body) {
    return requests.post(`/lesson/list`, body);
  },
  getLessonbyId(id) {
    return requests.get(`/lesson/${id}`);
  },
  uploadImage(body) {
    return requests.post(`/lesson/uploadimage`,body);
  },
  creteImages(body){
    return requests.post('/image/add',body);
  },
  deleteAzureImage(body){
    return requests.post(`/lesson/deleteazureimage`,body);

  },
  creteLesson(body){
    return requests.post('/lesson/add',body); 
  },
  deleteLesson(body){
    return requests.delete(`/lesson/${body._id}`); 
  },
  findLessonList(body){
    return requests.post(`/lesson/find`,body); 
  },
  upadeLesson(body) {
    return requests.put(`/lesson/${body._id}`,body); 
  },

};
export default LessonService;
